import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren, Inject, PLATFORM_ID, OnDestroy, AfterViewInit, OnChanges } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { EnvService } from 'src/app/services/env.service';
import { MainBodyService } from 'src/app/services/main-body.service';
import { favourites, listArticle } from 'src/interface/article';
import { themeData } from 'src/interface/themesetting';
import { ActivatedRoute } from '@angular/router';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { AlertService } from 'src/app/services/alert.service';
import { FavouriteService } from 'src/app/services/favourite.service';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
declare let gtag: Function;

@Component({
    selector: 'app-article-list',
    templateUrl: './article-list.component.html',
    styleUrls: ['./article-list.component.scss']
})
export class ArticleListComponent implements OnInit, OnDestroy, OnChanges {
    @Input() articleList: listArticle[] = [];
    @Input() isCollapsed: boolean[] = [];
    @Input() searchPipe: string;
    @Input() journalid: string;
    @Input() currentPage: number;

    @Input() loading: boolean;
    public abstract: boolean[] = [];
    isAngleDown: boolean[] = [];
    articleCoverImageUrl: string;
    defaultArticleCoverImage: string;
    fasttrack: boolean;
    @ViewChildren('authorDiv', { read: ElementRef }) myElements: QueryList<ElementRef>;
    themeSettingsData: themeData;
    // loading=true;
    items = new Array(4).fill(0);
    sharedUrl = '';
    titleShared = '';
    @ViewChild('dropdownMenuShare') dropdownMenuShare: ElementRef<HTMLDivElement>;
    disableBtnPdf = true;
    disableBtnXml = true;
    downloadCount = -1;
    downloadingData: { filename: string; download: boolean }[] = [];
    downloading: boolean;
    toggle_favourite: any[] = [];
    subscriptionArr: Subscription[] = [];
    default_article_cover_image_upto_11: string;
    default_article_cover_image_above_11: string;
    pdfExit = false;
    analyticsData: any
    constructor(
        private EnvService: EnvService, private mainBodyService: MainBodyService,
        private route: ActivatedRoute, private articleService: GetArticlesService,
        @Inject(PLATFORM_ID) private platformId: any,
        private alertService: AlertService, private favouriteService: FavouriteService,
        private analytics: GoogleAnalyticsService

    ) {
        const subscription = this.route.url.subscribe(segments => {
            if (segments.some(segment => segment.path === 'fasttrack')) {
                this.fasttrack = true;
            } else {
                this.fasttrack = false;
            }
        });
        this.subscriptionArr.push(subscription);
    }

    ngOnInit(): void {
        this.default_article_cover_image_upto_11 = this.EnvService.default_article_cover_image_upto_11;
        this.default_article_cover_image_above_11 = this.EnvService.default_article_cover_image_above_11;
        this.articleCoverImageUrl = this.EnvService.articleCoverImage;
        this.defaultArticleCoverImage = this.EnvService.defaultImagePath + this.EnvService.default_articleCoverImage;
        this.sharedUrl = this.EnvService.siteUrl;
        if (this.journalid) {
            this.disableBtnPdf = false;
            this.disableBtnXml = false;
            const subscription = this.mainBodyService.getAllThemeSettings(this.journalid).subscribe((result) => {
                if (result.status === 200) {
                    this.themeSettingsData = result.data;
                    if (isPlatformBrowser(this.platformId)) {
                        Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                            const element = "--" + key;
                            const val = value;
                            document.documentElement.style.setProperty(element, val);
                        });
                    }
                }
            });
            this.subscriptionArr.push(subscription);
        }
        // this.analytics.getAnalytics().subscribe((result: any) => {
        //     // this.analyticsData = result
        //     // this.articleList.forEach(element => {
        //     //     let url = "/articles/" + element.volume + "/" + element.issue + "/" + element.article_id
        //     //     const filteredData = this.analyticsData.filter(item =>
        //     //         item.dimensionValues[0].value === url
        //     //     );
        //     //     if (filteredData.length >= 1) {
        //     //         const pageViews = filteredData.filter(item => item.dimensionValues.some(dv => dv.value === 'page_view') && item.dimensionValues[0].value.includes('article'));
        //     //         const downloads = filteredData.filter(item => item.dimensionValues.some(dv => dv.value === 'download') && item.dimensionValues[0].value.includes('article'));
        //     //         console.log(pageViews);
        //     //         console.log(downloads);
        //     //         if (downloads.length == 1)
        //     //             element.download_count = downloads[0].metricValues[0].value
        //     //         if (pageViews.length == 1)
        //     //             element.view_count = pageViews[0].metricValues[0].value
        //     //         console.log(element.download_count, element.view_count);
        //     //     }
        //     // });
        // })
    }

    ngOnChanges() {
        this.articleList
        // this.articleList.forEach(element => {
        //     let url = "/article/" + element.volume + "/" + element.issue + "/" + element.article_id
        //     console.log(url);

        //     const filteredData = this.analyticsData.filter(item =>
        //         item.dimensionValues[0].value === url
        //     );
        //     console.log(filteredData);
        //     if (filteredData.length > 1) {
        //         const pageViews = filteredData.filter(item => item.dimensionValues.some(dv => dv.value === 'page_view') && item.dimensionValues[0].value.includes('article'));
        //         const downloads = filteredData.filter(item => item.dimensionValues.some(dv => dv.value === 'download') && item.dimensionValues[0].value.includes('article'));
        //         element.download_count = downloads[0].metricValues[0].value
        //         element.view_count = pageViews[0].metricValues[0].value
        //         console.log(element.download_count, element.view_count);

        //     }

        // });

    }

    returnArticle(author){
        let name = '';
        if(author?.specific_use == 'icwau'){
            name += 'in conversation with ';
        } else if(author?.specific_use == 'wffau'){
            name += 'with a Foreword from ';
        }
        name += author.first_name+' '+author.last_name;
        return name;
    }
    getArticleImageUrl(oneArticle) {

        let url = '';
        url = oneArticle.volume + '/' + oneArticle.issue + '/' + oneArticle.article_id + '/' + oneArticle.article_cover_image;
        return url;
    }
    showMoreAuthors(i: number) {
        this.isCollapsed[i] = !this.isCollapsed[i];
        this.myElements.toArray()[i].nativeElement.style.maxHeight = this.isCollapsed[i] ? 'none' : '50px';
    }
    abstractClick(i: number) {

        this.abstract[i] = !this.abstract[i];
        this.isAngleDown[i] = !this.isAngleDown[i];
    }

    openDropdown(menuType: string, article: listArticle, i: number) {
        if (isPlatformBrowser(this.platformId)) {
            const parentElement = document.querySelector(`.dropdown-${menuType}${i}`);
            if (parentElement) {
                const dropdownMenu = parentElement.querySelector('.dropdown-menu');
                if (dropdownMenu) {
                    this.disableBtnXml = false;
                    this.disableBtnPdf = false;
                    dropdownMenu.classList.add('show');
                    this.disableBtnPdf = false;
                    this.disableBtnXml = false;
                    this.titleShared = article.article_title
                    // this.sharedUrl = `${this.EnvService.siteUrl}/journal/${article.journal_id}/articles/${article.volume}/${article.issue}/${article.article_id}`;
                }
            }
        }
    }

    closeDropdown(menuType: string, i: number) {
        if (isPlatformBrowser(this.platformId)) {
            const parentElement = document.querySelector(`.dropdown-${menuType}${i}`);
            if (parentElement) {
                const dropdownMenu = parentElement.querySelector('.dropdown-menu');
                if (dropdownMenu) {
                    dropdownMenu.classList.remove('show');
                }
            }
        }
    }
    changeIssue(issue: any) {

        // Regular expression pattern to match 'and'
        const pattern = /and/;
        let outputString: string = 'Issue ' + issue;
        if (issue.match(pattern)) {
            // Replace 'and' with '/'
            outputString = 'Issue ' + issue.replace(pattern, ' & ');
        }

        // Regular expression pattern to match 's' followed by a number
        const nextpattern = /s(\d+)/;

        if (issue.match(nextpattern)) {
            const issue_num = issue.match(nextpattern)[1];
            // Replace 's' followed by a number with 'supplementary issue' followed by that number
            outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
        }

        if (issue == 'non-issue') {
            outputString = 'Regular articles';
        }

        return outputString;
    }


    downloadPdf(download_type: string, article: listArticle) {
        const artFilePath = article.art_file_path; // Replace with your actual variable

        const params = {
            doi: article.doi,
            published_date: article.published_online,
            journal_id: article.journal_id,
            journal_title: article.journal_title,
            volume: article.volume,
            issue: article.issue_id,
            article_id: article.article_id,
            article_title: article.article_title,
            art_file_path: article.art_file_path,
            download_type: download_type,
        };
        setTimeout(() => {
            const subscription = this.articleService.articleDownloadCount(params).subscribe({
                next: (data: Blob) => {
                    if (isPlatformBrowser(this.platformId)) {
                        this.downloadCount = this.downloadCount + 1;
                        // Split the string by slashes and select the last word
                        const words = artFilePath.split('/');
                        const lastWord = words[words.length - 1];
                        const downloaddata = {
                            filename: lastWord + '.' + download_type,
                            download: true,
                        };
                        this.downloadingData.push(downloaddata);
                        // download_type == 'pdf'
                        //     ? (this.disableBtnPdf = true)
                        //     : (this.disableBtnXml = true);
                        this.downloading = true;
                        const element = document.querySelector('#liveToast');
                        if (element) element.classList.add('show');
                        const blob = new Blob([data], {
                            type: 'application/pdf/xml',
                        });
                        
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'downloaded.' + download_type;
                        a.click();
                        if (this.downloadingData[this.downloadCount] != undefined)
                            this.downloadingData[this.downloadCount].download =
                                false;
                        this.downloading = false;
                        this.disableBtnPdf = false;
                        this.disableBtnXml = false;
                
                        setTimeout(() => {
                            if (element && this.downloading == false) {
                                element.classList.remove('show');
                                this.downloadingData = [];
                                this.downloadCount = -1;
                            }
                        }, 10000);
                        // const lastSlashIndex = article.art_file_path.lastIndexOf('/');
                        // const filename = article.art_file_path.substring(lastSlashIndex + 1);
                        if (download_type == 'pdf') {
                            if (isPlatformBrowser(this.platformId)) {
                                window.open(this.EnvService.articleImage + '/' + article.art_file_path + '/' + lastWord + '.' + download_type);
                                gtag('event', 'download_file', {
                                    'event_category': 'Downloads',
                                    'event_label': 'File.pdf'
                                });
                            }
                        }
                    }
                    
                },
                error: () => {
                    if (isPlatformBrowser(this.platformId)) {
                        const words = artFilePath.split('/');
                        const lastWord = words[words.length - 1];
                        const downloaddata = {
                            filename: lastWord + '.' + download_type,
                            download: true,
                        };
                        this.downloadingData.push(downloaddata);
                        this.pdfExit = true;
                        const element = document.querySelector('#liveToast');
                        if (element) element.classList.add('show');
                        setTimeout(() => {
                            if (element) {
                                element.classList.remove('show');
                                this.pdfExit = false;
                            }
                        }, 10000);
                    }
                },
            });
            this.subscriptionArr.push(subscription);
        }, 500);
    }

    downloadcount(count: number) {
        this.downloadCount = count;
    }

    addToFavourites(article: listArticle, i: number) {
        this.toggle_favourite[i] = !this.toggle_favourite[i];
        if (this.toggle_favourite[i]) {
            this.alertService.success('Added to favourites');
        }
        else {
            this.alertService.error('Removed from favourites');
        }

        const favourite: favourites = {
            jnl_id: article.journal_id,
            volume: article.volume,
            issue: article.issue,
            article_id: article.article_id
        }
        this.favouriteService.setFavourite(favourite);
    }

    toggleFavourite(article: listArticle, i: number) {
        const favourite_match: favourites = {
            jnl_id: article.journal_id,
            volume: article.volume,
            issue: article.issue,
            article_id: article.article_id
        }
        this.toggle_favourite[i] = this.favouriteService.getFavourite(favourite_match);
        return this.toggle_favourite[i];
    }
    ngOnDestroy() {
        this.subscriptionArr.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
    // Footnote xrefs in a title (e.g. <xref ref-type="fn" rid="fn1"><sup>1</sup></xref>)
    // are excluded entirely here, digit included, since this listing has no footnote
    // section/tooltip for the marker to refer to.
    private stripFootnoteXref(title: string): string {
        if (!title) {
            return title;
        }
        return title.replace(/<xref[^>]*ref-type=["']fn["'][^>]*>[\s\S]*?<\/xref>/gi, '');
    }

    getCleanTitle(title: string): string {
        return this.stripFootnoteXref(title).replace(/<[^>]*>/g, '');
    }
}
